import _toConsumableArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import './TopPicks.css';
import React from 'react';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import { get, canUseDOM, getDictionaryItem, getPageThemeColors, getColorByTheme } from '../../utils';
import { commonStyles, eventStyle, poiStyle, articleStyle, curatorStyle, stylesRTL, stylesLTR } from '../Listing/Listing';
import getListing from '../../utils/getListing';
import { loadMoreButtonStylesLtr } from '../DynamicListingComponent/DynamicListingComponent';
import { POIBlock } from './../34_POIs/POIs';
import { ArticleBlock } from '../02_Articles/Articles';
import EventBlock from "../15_Events/components/EventBlock";
import { ItenaryBlock, commonStyles as itemStyles } from '../26_Itineraries/Itineraries';
import { commonStyles as curatorltrStyles, rtlStyles as curatorRtlStyles } from '../10_Curators/Curators';
import { commonStyles as filterStyle } from '../Listing/Switch';
import LoadMore from '../DynamicListingComponent/LoadMore';
import heartLine from '../../resources/icons/heart-line.svg';
import { convertToAnalyticObject } from '../../utils/analytics';
import { RestaurantsCard } from '../atoms/RestaurantsCard/RestaurantsCard';
export var LOCAL_STORAGE_TOPPICKS_NAME = 'top-picks';
var EСheckboxLabelTypes = /*#__PURE__*/function (EСheckboxLabelTypes) {
  EСheckboxLabelTypes["Article"] = "Article";
  EСheckboxLabelTypes["POI"] = "POI";
  EСheckboxLabelTypes["Event"] = "Event";
  EСheckboxLabelTypes["Itineraries"] = "Itineraries";
  EСheckboxLabelTypes["Restaurant"] = "Restaurant";
  return EСheckboxLabelTypes;
}(EСheckboxLabelTypes || {});
var CheckBox = function CheckBox(_ref) {
  var index = _ref.index,
    item = _ref.item,
    label = _ref.label,
    checkboxRef = _ref.checkboxRef,
    setFilter = _ref.setFilter;
  return /*#__PURE__*/React.createElement("div", {
    key: index,
    className: "g-checkbox__item"
  }, /*#__PURE__*/React.createElement("input", {
    value: item,
    type: "checkbox",
    className: "fp__checkbox",
    id: "gct1-".concat(index),
    name: "gct1",
    onChange: function onChange(e) {
      var checkboxLength = checkboxRef.current.querySelectorAll('.fp__checkbox').length - checkboxRef.current.querySelectorAll('.fp__checkbox:checked').length;
      if (checkboxLength !== 0) {
        setFilter(e.target.value, e.target.checked);
      } else {
        e.target.checked = false;
      }
    },
    title: label
  }), /*#__PURE__*/React.createElement("label", {
    className: "body-small g-checkbox__label",
    htmlFor: "gct1-".concat(index)
  }, label));
};
var TopPicks = function TopPicks(_ref2) {
  var fields = _ref2.fields,
    params = _ref2.params;
  var sitecoreContext = React.useContext(SitecoreContextReactContext);
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var currentLang = get(sitecoreContext, 'language');
  var _React$useState = React.useState(),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    hits = _React$useState2[0],
    setHits = _React$useState2[1];
  var _React$useState3 = React.useState(),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    facets = _React$useState4[0],
    setFacets = _React$useState4[1];
  var _React$useState5 = React.useState(0),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    nbHits = _React$useState6[0],
    setnbHits = _React$useState6[1];
  var _React$useState7 = React.useState(0),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    nbPages = _React$useState8[0],
    setnbPages = _React$useState8[1];
  var _React$useState9 = React.useState(0),
    _React$useState10 = _slicedToArray(_React$useState9, 2),
    page = _React$useState10[0],
    setpage = _React$useState10[1];
  var _React$useState11 = React.useState(),
    _React$useState12 = _slicedToArray(_React$useState11, 2),
    result = _React$useState12[0],
    setResult = _React$useState12[1];
  var _React$useState13 = React.useState(false),
    _React$useState14 = _slicedToArray(_React$useState13, 2),
    emptyError = _React$useState14[0],
    setemptyError = _React$useState14[1];
  var _React$useState15 = React.useState({}),
    _React$useState16 = _slicedToArray(_React$useState15, 2),
    stateFilters = _React$useState16[0],
    setstateFilters = _React$useState16[1];
  var dictionary = get(fields, 'data.dictionary');
  var curatorPick = getDictionaryItem(dictionary, 'Curatorspick');
  var byCopy = getDictionaryItem(dictionary, 'By');
  var MinRead = getDictionaryItem(dictionary, 'MinRead');
  var day = getDictionaryItem(dictionary, 'day') || 'day';
  var days = getDictionaryItem(dictionary, 'days') || 'days';
  var EventFilterTitle = getDictionaryItem(dictionary, 'EventFilterTitle');
  var ItineraryFilterTitle = getDictionaryItem(dictionary, 'ItineraryFilterTitle');
  var PoiFilterTitle = getDictionaryItem(dictionary, 'PoiFilterTitle');
  var ArticleFilterTitle = getDictionaryItem(dictionary, 'article field title ');
  var RestaurantFilterTitle = getDictionaryItem(dictionary, 'RestaurantFilterTitle');
  var LoadMoreCopy = getDictionaryItem(dictionary, 'LoadMore');
  var eventCopy = getDictionaryItem(dictionary, 'event');
  var poiCopy = getDictionaryItem(dictionary, 'poi');
  var itineraryCopy = getDictionaryItem(dictionary, 'itinerary');
  var articleCopy = getDictionaryItem(dictionary, 'article');
  var errorMessage = getDictionaryItem(dictionary, 'AddItemsToYourTopPicks');
  var removedMessage = getDictionaryItem(dictionary, 'HasBeenRemoved');
  var YourTopPicksTitle = getDictionaryItem(dictionary, 'YourTopPicksTitle');
  var indexName = get(params, 'SearchIndex');
  var SearchCount = get(params, 'SearchCount') || 12;
  var countryItems = get(fields, 'data.countries.countryValues') || [];
  var _React$useState17 = React.useState(''),
    _React$useState18 = _slicedToArray(_React$useState17, 2),
    removedItemType = _React$useState18[0],
    setremovedItemType = _React$useState18[1];
  var _React$useState19 = React.useState(''),
    _React$useState20 = _slicedToArray(_React$useState19, 2),
    favButtonState = _React$useState20[0],
    setfavButtonState = _React$useState20[1];
  var _React$useState21 = React.useState([]),
    _React$useState22 = _slicedToArray(_React$useState21, 2),
    objectIdState = _React$useState22[0],
    setobjectIdState = _React$useState22[1];
  var _React$useState23 = React.useState(true),
    _React$useState24 = _slicedToArray(_React$useState23, 2),
    isVdsite = _React$useState24[0],
    setIsVdsite = _React$useState24[1];
  var checkboxRef = /*#__PURE__*/React.createRef();
  var filterRef = React.useRef();
  var hasItenaryFilter = false;
  ///let timer: any;
  //  let parsedId: any;
  var _React$useState25 = React.useState(''),
    _React$useState26 = _slicedToArray(_React$useState25, 2),
    parsedId = _React$useState26[0],
    setparsedId = _React$useState26[1];
  var _React$useState27 = React.useState(''),
    _React$useState28 = _slicedToArray(_React$useState27, 2),
    timer = _React$useState28[0],
    settimer = _React$useState28[1];
  var viewedNofMLabel = "".concat(getDictionaryItem(dictionary, 'YouHaveViewed'), " {#loadedHits#} ").concat(getDictionaryItem(dictionary, 'Of'), " {#nbHits#} ").concat(getDictionaryItem(dictionary, 'Items'));
  var checkboxLabelMap = {
    "Article": ArticleFilterTitle,
    "POI": PoiFilterTitle,
    "Event": EventFilterTitle,
    "Itineraries": ItineraryFilterTitle,
    "Restaurant": RestaurantFilterTitle
  };
  var types = ['type:Article', 'type:POI', 'type:Event', 'type:Itineraries', 'type:Restaurant'];
  var _React$useState29 = React.useState(types),
    _React$useState30 = _slicedToArray(_React$useState29, 2),
    filterTypes = _React$useState30[0],
    setfilterTypes = _React$useState30[1];
  var primaryPageThemeColor = get(sitecoreContext, 'themesOfPage.primary');
  var selectedPrimaryColor = primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary;
  var _React$useState31 = React.useState(false),
    _React$useState32 = _slicedToArray(_React$useState31, 2),
    overlayButton = _React$useState32[0],
    setOverlayButton = _React$useState32[1];
  var RemoveButtonOvelray = function RemoveButtonOvelray() {
    return /*#__PURE__*/React.createElement("div", {
      className: "".concat(overlayButton ? 'remove-button-overlay remove-button-overlay--active' : 'remove-button-overlay'),
      onClick: function onClick() {
        setOverlayButton(false);
        removeItem(parsedId);
        clearTimeout(timer);
      }
    }, rtl ? "".concat(removedMessage, " ").concat(removedItemType) : "".concat(removedItemType, " ").concat(removedMessage));
  };
  // let objectId: any=[];
  var items;
  // let objectId: any = [];
  // if (canUseDOM) {
  //   if (localStorage.getItem(LOCAL_STORAGE_TOPPICKS_NAME) !== null) {
  //     items = JSON.parse(localStorage.getItem(LOCAL_STORAGE_TOPPICKS_NAME) as any);
  //   }
  // }

  // const objectId =
  //   get(items, 'list', []).map((item: any) => {
  //     return `objectID:${item.itemId.split('-').join('')}`;
  //   }) || [];

  React.useEffect(function () {
    if (canUseDOM && !document.body.classList.contains('vdsite')) {
      setIsVdsite(false);
    }
  }, []);
  React.useEffect(function () {
    if (canUseDOM) {
      if (localStorage.getItem(LOCAL_STORAGE_TOPPICKS_NAME) !== null) {
        items = JSON.parse(localStorage.getItem(LOCAL_STORAGE_TOPPICKS_NAME));
      }
    }
    var objectId = get(items, 'list', []).map(function (item) {
      return "objectID:".concat(item && item.itemId && item.itemId.split('-').join(''));
    }) || [];
    setobjectIdState(objectId);
    if (objectId.length === 0) {
      setemptyError(true);
      return;
    }
    // let itemFilters: any;

    var itemFilters = _objectSpread(_objectSpread({}, stateFilters), {}, {
      facets: ['type'],
      facetFilters: [types, _toConsumableArray(objectId)],
      hitsPerPage: SearchCount
    });
    if (Object.keys(stateFilters).length === 0) {
      itemFilters = _objectSpread(_objectSpread({}, stateFilters), {}, {
        facets: ['type'],
        facetFilters: [types, _toConsumableArray(objectId)],
        hitsPerPage: SearchCount
      });
    } else {
      itemFilters = _objectSpread({}, stateFilters);
      itemFilters = _objectSpread(_objectSpread({}, stateFilters), {}, {
        facets: ['type'],
        facetFilters: [stateFilters.facetFilters[0], _toConsumableArray(objectId)],
        hitsPerPage: SearchCount
      });
    }
    getListing(indexName, itemFilters).then(function (response) {
      setHits(response.hits);
      setnbPages(response.nbPages);
      setnbHits(response.nbHits);
      setpage(1);
      setResult(response);
      setFacets(response.facets);
      setstateFilters(itemFilters);
      if (response.hits.length === 0) {
        setemptyError(true);
      }
      // setTimeout(function() {
      //   if (canUseDOM) {
      //     window.onscroll = () => {};
      //   }
      // }, 100);
    });
  }, [favButtonState]);
  var setFilter = function setFilter(value, isChecked) {
    var filteredAry = [];
    var checkboxes = checkboxRef.current.querySelectorAll('.fp__checkbox');
    for (var index = 0; index < checkboxes.length; index++) {
      var element = checkboxes[index];
      if (element.checked) {
        filteredAry.push('type:' + element.value);
      }
    }
    var filterTypes = types.filter(function (val) {
      return !filteredAry.includes(val);
    });
    // filterTypes
    setfilterTypes(filterTypes);
    if (canUseDOM) {
      if (localStorage.getItem(LOCAL_STORAGE_TOPPICKS_NAME) !== null) {
        items = JSON.parse(localStorage.getItem(LOCAL_STORAGE_TOPPICKS_NAME));
      }
    }
    var objectId = get(items, 'list', []).map(function (item) {
      return "objectID:".concat(item && item.itemId && item.itemId.split('-').join(''));
    }) || [];
    //setobjectIdState(objectId);
    // if (objectId.length === 0) {
    //   setemptyError(true);
    //   return;
    // }
    var itemFilters = _objectSpread(_objectSpread({}, stateFilters), {}, {
      facets: ['type'],
      facetFilters: [_toConsumableArray(filterTypes), _toConsumableArray(objectId)]
    });
    getListing(indexName, itemFilters).then(function (response) {
      setHits(response.hits);
      setnbPages(response.nbPages);
      setnbHits(response.nbHits);
      setResult(response);
      setpage(1);
      setstateFilters(itemFilters);
    });
    // }
  };
  var loadMore = function loadMore() {
    // if (canUseDOM) {

    //   var x = window.scrollX;
    //   var y = window.scrollY;
    //   const scrollEvent = () => {
    //     window.scrollTo(x, y);
    //   };
    // //  window.addEventListener('onscroll', scrollEvent)
    //   // window.onscroll =
    // }
    if (result.page < result.nbPages) {
      setpage(function (prevState) {
        return prevState + 1;
      });
      var itemFilter = _objectSpread(_objectSpread({}, stateFilters), {}, {
        page: page
      });
      getListing(indexName, itemFilter).then(function (response) {
        setnbPages(response.nbPages);
        setResult(response);
        setnbHits(response.nbHits);
        if (hits) {
          setHits(hits.concat(response.hits));
        } else {
          setHits(response.hits);
        }
      });
    }
  };
  var removeFav = function removeFav(id) {
    setOverlayButton(false);
    setparsedId(id.split('-').join(''));
    setOverlayButton(true);

    // setFilter()
    // setTimeout(() => {

    //   // setfavButtonState(parsedId);
    // }, 10);

    var timer = setTimeout(function () {
      removeItem(id.split('-').join(''));
      if (canUseDOM) {
        if (localStorage.getItem(LOCAL_STORAGE_TOPPICKS_NAME) !== null) {
          items = JSON.parse(localStorage.getItem(LOCAL_STORAGE_TOPPICKS_NAME));
        }
      }
      var objectId = get(items, 'list', []).map(function (item) {
        return "objectID:".concat(item && item.itemId && item.itemId.split('-').join(''));
      }) || [];
      var itemFilter = _objectSpread(_objectSpread({}, stateFilters), {}, {
        facets: ['type'],
        facetFilters: [_toConsumableArray(filterTypes), _toConsumableArray(objectId)]
      });
      getListing(indexName, itemFilter).then(function (response) {
        // setnbPages(response.nbPages);
        // setResult(response);
        // if(!get(response,"facets.type.POI")){
        //   setpoiFilter(false)
        // }
        // if(!get(response,"facets.type.Article")){
        //   setarticleFilter(false)
        // }
        // if(!get(response,"facets.type.Event")){
        //   seteventFilter(false)
        // }
        // if(!get(response,"facets.type.Itineraries")){
        //   setitenaryFilter(false)
        // }
      });
      setOverlayButton(false);
      clearTimeout(timer);
    }, 2000);
    settimer(timer);
  };
  var removeItem = function removeItem(parsedId) {
    //
    var updatedHits = hits.filter(function (hit) {
      if (hit.objectID !== parsedId) {
        return hit;
      }
    });
    setTimeout(function () {
      if (updatedHits.length === 0) {
        if (filterRef.current.querySelectorAll('.fp__checkbox').length === 1) {
          setemptyError(true);
          filterRef.current.style.display = 'none';
        }

        // if (checkboxRef.current) {
        //   checkboxRef.current.style.display = 'none';
        // }
      }
    }, 10);
    setHits(updatedHits);
  };
  var _fields$data = fields.data,
    bannerClickAnalytics = _fields$data.bannerClickAnalytics,
    titleClickAnalytics = _fields$data.titleClickAnalytics,
    navBubblesAnalytics = _fields$data.navBubblesAnalytics,
    prevNextNavAnalytics = _fields$data.prevNextNavAnalytics,
    addToFavAnalytics = _fields$data.addToFavAnalytics,
    exploreMoreAnalytics = _fields$data.exploreMoreAnalytics,
    mobileSlidesAnalytics = _fields$data.mobileSlidesAnalytics,
    seeMoreAnalytics = _fields$data.seeMoreAnalytics,
    smallBannerClickAnalytics = _fields$data.smallBannerClickAnalytics;
  var eventsAnalytics = get(fields, 'data.eventsAnalytics') || [];
  if (eventsAnalytics.length) {
    eventsAnalytics = convertToAnalyticObject(eventsAnalytics);
  }
  return /*#__PURE__*/React.createElement(ComponentsWrapper, null, /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl
  }, /*#__PURE__*/React.createElement("div", {
    className: "row top-picks"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-12 col-md-9 offset-xl-1"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "h3"
  }, YourTopPicksTitle), emptyError && /*#__PURE__*/React.createElement("p", {
    className: "top-picks__desc"
  }, errorMessage.split('##heart##')[0], " ", /*#__PURE__*/React.createElement("img", {
    className: "icon",
    alt: "icon",
    title: "icon",
    src: heartLine
  }), ' ', errorMessage.split('##heart##')[1]), /*#__PURE__*/React.createElement("div", {
    className: "filters"
  }, /*#__PURE__*/React.createElement("div", {
    className: "filter-toggle-multi-select",
    ref: filterRef
  }, /*#__PURE__*/React.createElement("div", {
    className: "g-checkbox g-checkbox--mob-scroll",
    ref: checkboxRef
  }, facets && facets.type && Object.keys(facets.type).map(function (item, index) {
    return /*#__PURE__*/React.createElement(CheckBox, {
      item: item,
      key: index,
      index: index,
      label: checkboxLabelMap[item],
      checkboxRef: checkboxRef,
      setFilter: setFilter
    });
  })))), /*#__PURE__*/React.createElement("div", {
    className: "results"
  }, /*#__PURE__*/React.createElement("div", {
    className: "common-listing-styles"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row",
    style: {
      rowGap: '20px'
    }
  }, hits && hits.map(function (hit, index) {
    if (hit.type[0] === 'POI') {
      return /*#__PURE__*/React.createElement("div", {
        // style={hit.objectID === removedId ? { display: 'none' } : {}}
        className: "poi-styles col-12 col-sm-6 col-md-4",
        onClick: function onClick() {
          setremovedItemType(poiCopy);
        },
        key: index
      }, /*#__PURE__*/React.createElement("div", {
        className: " poi-item-col"
      }, /*#__PURE__*/React.createElement(POIBlock, {
        item: hit,
        callback: removeFav,
        curatorsCopy: curatorPick,
        hostLink: '',
        analytics: {
          bannerClickAnalytics: bannerClickAnalytics,
          titleClickAnalytics: titleClickAnalytics,
          navBubblesAnalytics: navBubblesAnalytics,
          prevNextNavAnalytics: prevNextNavAnalytics,
          addToFavAnalytics: addToFavAnalytics,
          exploreMoreAnalytics: exploreMoreAnalytics,
          mobileSlidesAnalytics: mobileSlidesAnalytics,
          smallBannerClickAnalytics: smallBannerClickAnalytics,
          params: params
        },
        dictionary: getDictionaryItem(dictionary, 'reviews') || ''
      })));
    }
    if (hit.type[0] === 'Restaurant') {
      return /*#__PURE__*/React.createElement("div", {
        className: "col-12 col-sm-6 col-md-4",
        key: index
      }, /*#__PURE__*/React.createElement(RestaurantsCard, {
        params: params,
        item: hit,
        reviews: getDictionaryItem(dictionary, 'reviews') || '',
        rtl: rtl,
        isGetFullUrl: true
      }));
    }
    if (hit.type[0] === 'Event') {
      return /*#__PURE__*/React.createElement("div", {
        className: "event-styles col-3 col-12 col-sm-6 col-md-4",
        onClick: function onClick() {
          setremovedItemType(eventCopy);
        },
        key: index
      }, /*#__PURE__*/React.createElement("div", {
        className: " events-item-col-outer"
      }, /*#__PURE__*/React.createElement(EventBlock, {
        event: hit,
        curatorsCopy: curatorPick,
        callback: removeFav,
        lang: currentLang,
        hostLink: '',
        analytics: {
          titleClickAnalytics: titleClickAnalytics,
          bannerClickAnalytics: bannerClickAnalytics,
          addToFavAnalytics: addToFavAnalytics,
          seeMoreAnalytics: seeMoreAnalytics,
          eventsAnalytics: eventsAnalytics,
          smallBannerClickAnalytics: smallBannerClickAnalytics,
          params: params
        },
        countryItems: countryItems,
        themeValues: [selectedPrimaryColor, getColorByTheme(selectedPrimaryColor)]
      })));
    }
    if (hit.type[0] === 'Article') {
      return /*#__PURE__*/React.createElement("div", {
        className: "article-styles col-12 col-sm-6 col-md-4",
        onClick: function onClick() {
          setremovedItemType(articleCopy);
        },
        key: index
      }, /*#__PURE__*/React.createElement("div", {
        className: " article-item-col "
      }, /*#__PURE__*/React.createElement(ArticleBlock, {
        item: hit,
        copyBy: byCopy,
        copyMinread: MinRead,
        callback: removeFav,
        lang: currentLang,
        hostLink: '',
        analytics: {
          eventsAnalytics: eventsAnalytics,
          params: params
        }
      })));
    }
  }), hits && hits.map(function (hit, index) {
    if (hit.type[0] === 'Itineraries') {
      return /*#__PURE__*/React.createElement("div", {
        className: "col-12",
        onClick: function onClick() {
          setremovedItemType(itineraryCopy);
        },
        key: index
      }, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: " itinerary-styles col-12"
      }, /*#__PURE__*/React.createElement("div", {
        className: "curator-featured"
      }, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "curator-container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "curator-container__row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "curator-main-container"
      }, /*#__PURE__*/React.createElement(ItenaryBlock, {
        item: hit,
        day: day,
        callback: removeFav,
        curatorsCopy: curatorPick,
        days: days,
        hostLink: '',
        analytics: {
          bannerClickAnalytics: bannerClickAnalytics,
          titleClickAnalytics: titleClickAnalytics,
          navBubblesAnalytics: navBubblesAnalytics,
          prevNextNavAnalytics: prevNextNavAnalytics,
          addToFavAnalytics: addToFavAnalytics,
          exploreMoreAnalytics: exploreMoreAnalytics,
          mobileSlidesAnalytics: mobileSlidesAnalytics,
          seeMoreAnalytics: seeMoreAnalytics,
          params: params
        }
      })))))))));
    }
  }), /*#__PURE__*/React.createElement(RemoveButtonOvelray, null))))), /*#__PURE__*/React.createElement("div", {
    className: "col-12 col-md-9 offset-xl-1"
  }, hits && nbPages > page && /*#__PURE__*/React.createElement(LoadMore, {
    buttonLabel: LoadMoreCopy,
    onClick: loadMore,
    nbHits: nbHits,
    loadedHits: hits && hits.length,
    viewedNofMLabel: viewedNofMLabel
  })))));
};
var globalStyles = "g12pusza";
export var StyledWrapper = function StyledWrapper(_ref3) {
  var children = _ref3.children,
    rtl = _ref3.rtl;
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(commonStyles, "  ").concat(eventStyle, " ").concat(poiStyle, " ").concat(globalStyles, " ").concat(articleStyle, " ").concat(itemStyles, " ").concat(loadMoreButtonStylesLtr, " ").concat(filterStyle, " ").concat(curatorltrStyles, " ").concat(curatorStyle, " ").concat(topPicksStyles, " ").concat(rtl ? curatorRtlStyles : curatorltrStyles, " ").concat(rtl ? stylesRTL : stylesLTR, "  ").concat(rtl ? stylesSpecificRTL : stylesSpecificLTR, "  ")
  }, children);
};
var topPicksStyles = "tb0jwc3";
var stylesSpecificLTR = "sopke6e";
var stylesSpecificRTL = "soutc48";
export default TopPicks;